
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import router from '../router'
import backend from '@/modules/Backend'
import auth from '@/modules/Auth'
import { t } from '@/modules/Translation'

const collect = require('collect.js')

const relationOptions = collect(['father', 'mother', 'parents', 'others'])
  .map((key) => {
    return {key: key, value: t.trans(key)}
  }).all()

const initState = {
  email: '',
  password: '',
  username: '',
  fullname: '',
  usertype: '',
  relation: '请选择身份关系',
  step: 'to_auth',
  errorInfo: {
    auth: '',
    link: ''
  },
  relationOptions
}

let authData = {}

export default {
  directives: {
    TransferDom
  },
  components: {
    Group,
    Cell,
    XHeader,
    XInput,
    XButton,
    PopupRadio,
    Loading,
    Flexbox,
    FlexboxItem,
    TransferDom
  },
  data () {
    return Object.assign({}, initState)
  },
  methods: {
    gotoAuth (reset = false) {
      if (reset === true) {
        return Object.assign(this.$data, initState)
      }
      this.step = 'to_auth'
    },
    doAuth () {
      this.errorInfo.auth = ''
      if (!this.password || !this.email) {
        this.errorInfo.auth = 'Email或密码不能为空！'
        return
      }
      backend.authCredential(this.email, this.password)
        .then(({user, token}) => {
          this.errorInfo.auth = ''
          this.username = user.username
          this.usertype = t.trans(user.type)
          this.fullname = user.last_name + ' ' + user.first_name
          authData = { userId: user.id, token }
          this.gotoLink()
        }).catch(({response}) => {
          const {data: body} = response
          if ((body.code === 4003) || (body.code === 4004)) {
            this.errorInfo.auth = 'Email或密码不正确'
          } else {
            this.errorInfo.auth = '出错了! 请稍后再试. 如果错误持续, 请联系管理员.'
          }
        })
    },
    gotoLink () {
      this.errorInfo.link = ''
      this.step = 'to_link'
    },
    doLink () {
      backend.link(this.wuid, this.relation, authData.userId, authData.token)
        .then(() => {
          this.errorInfo.link = ''
          auth.refresh().then(() => { this.$vux.loading.hide() })
          this.step = 'to_confirm'
        }).catch(({response}) => {
          this.$vux.loading.hide()
          const {data: body} = response
          if (body.code === 4005) {
            this.errorInfo.link = '出错了，您已经关联过该用户'
          } else {
            this.errorInfo.link = '出错了! 请稍后再试. 如果错误持续存在, 请联系管理员.'
          }
        })
      this.$vux.loading.show()
    },
    async confirm () {
      await auth.switch(authData.userId)
      router.push('homeworks')
    },
    _ (key) {
      return t.trans(key)
    }
  },
  computed: {
    newRegister () {
      return !this.$store.state.authenticated
    },
    wuid () {
      return this.$store.state.wuid
    },
    text () {
      return this.newRegister
        ? {
          title: '欢迎',
          intro: '欢迎使用OctoMaster微信小应用，此应用可以帮助您方便快捷地查看学生的最新学习情况。'
        }
        : {
          title: '新增关联',
          intro: '你的微信账号可以关联多个Octomaster用户 (例如多个子女)。'
        }
    }
  },
  mounted () {
  }
}



// WEBPACK FOOTER //
// ./src/components/Register.vue